import { APPLICATION_ROLES } from '../constants/app-data.constants';

import { LoggedInUserRoleFlags } from '../interfaces/logged-in-user-role-flags.interface';

export class LoggedInUserRoleFlagsHelper {

  constructor(roles: string[]) {

    roles ??= [];
    const hasRole = (roleName: string) => roles.includes(roleName);

    this._roleFlags = {
      isMaatManager: hasRole(APPLICATION_ROLES.maat.manager),
      isMaatSeniorProjectOfficer: hasRole(APPLICATION_ROLES.maat.seniorProjectOfficer),
      isMaatProjectOfficer: hasRole(APPLICATION_ROLES.maat.projectOfficer),
      isMaatHeadContractor: hasRole(APPLICATION_ROLES.maat.headContractor),
      isPcrAdmin: hasRole(APPLICATION_ROLES.pcr.admin),
      isPcrPasManager: hasRole(APPLICATION_ROLES.pcr.pasManager),
      isPcrPasUser: hasRole(APPLICATION_ROLES.pcr.pasUser),
      isPcrVendorManager: hasRole(APPLICATION_ROLES.pcr.vendorManager),
      isPcrInspector: hasRole(APPLICATION_ROLES.pcr.inspector)
    }
  }

  get roleFlags(): LoggedInUserRoleFlags { return this._roleFlags; }

  private _roleFlags: LoggedInUserRoleFlags;
}
